import React, { ReactNode, useState } from 'react';
import { TInvestFundCurrency } from '../../../../apps/investor/types/fund/TInvestFundCurrency';

const noop = () => {
	null;
};

type IAppNavigationContext = {
	displayShareLink: boolean;
	setDisplayShareLink: (displayShareLink: boolean) => void;

	displayCurrencySelector: boolean;
	setDisplayCurrencySelector: (displayCurrencySelector: boolean) => void;

	currentCurrency: TInvestFundCurrency;
	setCurrentCurrency: (currency: TInvestFundCurrency) => void;
	resetCurrentCurrency: () => void;
};

const AppNavigationContext = React.createContext<IAppNavigationContext>({
	displayShareLink: false, // Valeur par défaut
	setDisplayShareLink: () => {
		null;
	},

	displayCurrencySelector: false, // Valeur par défaut
	setDisplayCurrencySelector: () => {
		null;
	},

	currentCurrency: null,
	setCurrentCurrency: noop,
	resetCurrentCurrency: noop,
});

export const useAppNavigationContext = () => {
	return React.useContext(AppNavigationContext);
};

type AppNavigationProviderProps = {
	children?: ReactNode;
};

const AppNavigationProvider: React.FC<AppNavigationProviderProps> = ({ children }) => {
	const [displayShareLink, changeDisplayShareLink] = useState<boolean>(
		localStorage.getItem('appNavigation.displayShareLink')
			? localStorage.getItem('appNavigation.displayShareLink') === 'true'
				? true
				: false
			: false,
	);

	const setDisplayShareLink = (value: boolean) => {
		changeDisplayShareLink(value);
		localStorage.setItem('appNavigation.displayShareLink', value === true ? 'true' : 'false');
	};

	// displayCurrencySelector
	const [displayCurrencySelector, changeDisplayCurrencySelector] = useState<boolean>(
		localStorage.getItem('appNavigation.displayCurrencySelector')
			? localStorage.getItem('appNavigation.displayCurrencySelector') === 'true'
				? true
				: false
			: false,
	);

	const setDisplayCurrencySelector = (value: boolean) => {
		changeDisplayCurrencySelector(value);
		localStorage.setItem('appNavigation.displayCurrencySelector', value === true ? 'true' : 'false');
	};

	// currentCurrency
	const [currentCurrency, changeCurrentCurrency] = useState<TInvestFundCurrency | null>(
		localStorage.getItem('authCurrentCurrency') === 'EUR'
			? 'EUR'
			: localStorage.getItem('authCurrentCurrency') === 'USD'
			? 'USD'
			: null,
	);
	const setCurrentCurrency = (currency: TInvestFundCurrency | null) => {
		if (currency === null) {
			localStorage.removeItem('authCurrentCurrency');
		} else if (currency !== undefined) {
			localStorage.setItem('authCurrentCurrency', currency.toString());
		}
		changeCurrentCurrency(currency);
	};
	const resetCurrentCurrency = () => {
		changeCurrentCurrency(null);
		localStorage.removeItem('authCurrentCurrency');
	};

	const contextValue = React.useMemo(() => {
		return {
			displayShareLink,
			setDisplayShareLink,
			displayCurrencySelector,
			setDisplayCurrencySelector,
			currentCurrency,
			setCurrentCurrency,
			resetCurrentCurrency,
		};
	}, [currentCurrency, displayCurrencySelector, displayShareLink]);

	return <AppNavigationContext.Provider value={contextValue}>{children}</AppNavigationContext.Provider>;
};

export default AppNavigationProvider;
